<template>
  <b-container v-if="this.maintenance" class="d-flex flex-column justify-content-center align-items-center" >
    <br><br>
    <img
          :src="require('@/assets/images/InfoAM.png')"
          class="logo"
        >

        <br>
        <h1>AndyMark Info</h1>

        <h2>DOWN FOR MAINTENANCE</h2>
  </b-container>
  <b-container v-else-if="this.version && this.loggedInUser" fluid style="height: 100%; position: fixed;">
  <b-row style="height: 100%;">
    <b-col lg="3">
    <iframe
      style="height: calc(100% - 64px); width: 100%;"
      src="https://docs.google.com/spreadsheets/d/e/2PACX-1vSkpxKdOGF8B1tEFsxAyfqWDe8EtcG58wXY2zoXeb2LE3PdVgljCdm_EKtIjQ_jJqCsTvq4k_uU1_wc/pubhtml?gid=494050848&single=true&headers=false&range=A1:C50"
    />
    </b-col>
    <b-col>
      <iframe
      style="height: calc(100% - 64px); width: 100%;"
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vS31D_xkoGpUq-IsqLGrYkJTHoJQ0I8bU3Bl5fuyFeqsw9LHhxjY_TrkRcY__3BnrGsyhc5SfWvZEPz/pubhtml?gid=0&single=true&headers=false&range=A1:F45"
    />
    </b-col>
  </b-row>
  </b-container>
  <b-container v-else class="d-flex flex-column justify-content-center align-items-center">
    <br><br>
    <img
          :src="require('@/assets/images/InfoAM.png')"
          class="logo"
        >

        <br>
        <h1>AndyMark Info</h1>

        <h2>EMPLOYEES ONLY!</h2>

        <br>

        <a :href="login_link">Log In with your andymark.com email</a>
  </b-container>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  data() {
    return {
      version: null,
      maintenance: null,
    }
  },
  mounted() {
    axios.get(`${BASE_API}/../maintenance`).then((r) => { this.maintenance = r.data })
    axios.get(`${BASE_API}/version`).then((r) => { this.version = r.data })
    this.getLoggedInUser();
  },
  methods: {
    ...mapActions({
      getLoggedInUser: 'getLoggedInUser',
    }),
  },
  computed: {
    ...mapGetters({
      loggedInUser: 'loggedInUser',
    }),
    login_link() {
      if (this.version == 'localdev') {
        return 'http://localhost:5000/google/auth';
      }
      else {
        return '/google/auth'
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue